import React from 'react';
import ChatScreenEnhanced from '../../src/screens/chat/ChatScreenEnhanced';

/**
 * Chat Route - Professional Design with React Native Reusables
 * 
 * Enhanced Features:
 * - Fixed session management and persistence
 * - Responsive design system components
 * - Complete i18n support
 * - Proper scroll behavior
 * - Redesigned modals
 */
export default function ChatRoute() {
  return <ChatScreenEnhanced />;
}
